import { useState } from "react";
import { Play } from "lucide-react";
import { useTimer } from "@/context/TimerContext";
import { TIME_CATEGORIES } from "@/lib/constants";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function StartTimerModal({ open, setOpen, client }) {
  const { timer, start } = useTimer();
  const [category, setCategory] = useState("community");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      await start(client.id, category, note);
      toast.success(`Chronomètre démarré pour ${client.name}`);
      setOpen(false); setNote("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Impossible de démarrer le chronomètre");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md" data-testid="timer-start-modal" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="font-heading">Démarrer le chrono</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg px-4 py-3">
            <p className="text-xs text-neutral-400">Client</p>
            <p className="font-medium" data-testid="timer-start-client">{client?.name}</p>
          </div>
          {timer && timer.client_id !== client?.id && (
            <p className="text-sm text-orange-600 bg-orange-50 border border-orange-200 rounded-md px-3 py-2" data-testid="timer-start-warning">
              Un chronomètre est déjà actif pour {timer.client_name} — terminez-le d'abord.
            </p>
          )}
          <div>
            <Label>Type de travail</Label>
            <select data-testid="timer-start-category" value={category} onChange={(e) => setCategory(e.target.value)}
              className="mt-1.5 w-full text-sm border border-neutral-200 rounded-md px-2.5 py-2 bg-white">
              {TIME_CATEGORIES.map((c) => <option key={c.id} value={c.id}>{c.label}</option>)}
            </select>
          </div>
          <div>
            <Label>Note <span className="text-neutral-400 font-normal">(optionnel)</span></Label>
            <textarea data-testid="timer-start-note" value={note} onChange={(e) => setNote(e.target.value)} rows={2}
              placeholder="Ex : création des publications de septembre"
              className="mt-1.5 w-full text-sm border border-neutral-200 rounded-md px-2.5 py-2 bg-white" />
          </div>
          <Button data-testid="timer-start-submit" onClick={run} disabled={loading || (timer && timer.client_id !== client?.id)}
            className="w-full bg-neutral-900 hover:bg-neutral-800 text-white gap-1.5">
            <Play className="w-4 h-4" /> {loading ? "Démarrage…" : "Démarrer"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
